import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps, useHistory } from 'react-router-dom';
import queryString from 'query-string';

// redux
import { closeMenu } from 'store'
import { useDispatch } from 'react-redux';

// component
import Header from 'component/Header';
import SubHeader from 'component/SubHeader';
import Menu from 'component/Menu';
import Footer from 'component/Footer';
import FloorMap3 from 'component/FloorMap3';
import FloorMap4 from 'component/FloorMap4';

// function
import MoveWithMarketo from 'function/MoveWithMarketo';

import './PageIndex.scss';

type Props = {
  testPath: string,
} & RouteComponentProps<{floor: string, area: string}>;

const PageIndex: React.FC<Props> = (props) => {

  // dispatch
  const dispatch = useDispatch();

  // state
  const [isLoading, setIsLoading] = useState(true);
  const [isIntro, setIsIntro] = useState(false);

  // history
  const history = useHistory();

  // Effect
  useEffect(() => {
    // ページ遷移時にメニューを閉じる
    return () => {
      dispatch(closeMenu());
    }
  });
  // Effect
  useEffect(() => {

    let loadingTimer:NodeJS.Timeout;

    // クエリ取得
    const qs = queryString.parse(props.location.search);

    // スキップ判断
    if(qs.nointro === '1'){
      setIsLoading(false);
    }else{

      (window as any).addEventListener("load",()=>{

        console.log('ローディング完了')

        // イントロアニメ開始クラス付与
        setIsIntro(true)

        // イントロアニメ終了
        loadingTimer = setTimeout(()=>{
          setIsLoading(false)
        },7000);

      });

      return () => {
        clearTimeout(loadingTimer);
      }
    }
  },[props.location.search]);

  return (
    <div id="PageIndex" className={isLoading?'isLoading':''}>
      <Header />
      <Menu />
      <SubHeader active={0} />

      <section id="mainVisual" className={isIntro?'isIntro':''}>
        <div className="normal">
          {/* <div className="img"><img src={`${props.testPath}/asset/index/mainVisualText.png`} alt="" /></div> */}
          <div className="bg1"></div>
          <div className="bg2"></div>
          <div className="bg3"></div>
          <div className="txtGroup">
            <div className="txt1"><img src={`${props.testPath}/asset/index/mainVisualText01.png`} alt="" /></div>
            <div className="txt2"><img src={`${props.testPath}/asset/index/mainVisualText02.png`} alt="" /></div>
            <div className="txt3"><img src={`${props.testPath}/asset/index/mainVisualText03.png`} alt="" /><span><img src={`${props.testPath}/asset/index/mainVisualTextCircle.png`} alt="" /></span></div>
          </div>
        </div>
        <div className="intro">
          <div className="txtGroup">
            <div className="circle"></div>
            <div className="txt1">KOKUYO TOKYO SHOWROOM</div>
            <div className="txt2">LOADING</div>
          </div>
          <div className="bgGroup">
            <ul>
              <li className="num1"></li>
              <li className="num2"></li>
              <li className="num3"></li>
              <li className="num4"></li>
              <li className="num5"></li>
              <li className="num6"></li>
              <li className="num7"></li>
              <li className="num8"></li>
              <li className="num9"></li>
            </ul>
          </div>
        </div>
      </section>

      <section id="message">
        <h3>すべては、働き方を新しくするために。</h3>
        <p className="lead">社会が大きく変わろうとしているなか、<br className="hideSp" />
          その先を見据えた働き方をつくる<br className="hideSp" />
          多彩な製品が揃ったコクヨ東京ショールーム。<br/>
          実際に見て、触れて、あるいはオンラインでリアルに体感して、<br className="hideSp" />
          本当に必要としていた家具との出会いがここにあります。
        </p>
      </section>

      <section id="concept">
        <p className="lead1"><span>家具を通して、これからのオフィスの在り方を提案する<br className="hideSp" />コクヨ東京ショールーム。</span></p>        
        <p className="lead2">オフィス家具、それは働く人をサポートしてビジネスの可能性を広げるもの。<br />
          さまざまな組み合わせにより個性あふれる空間が生まれ、働き方を新しくします。<br />
          コクヨでは多彩な家具を通して、これからのオフィスの在り方を提案します。</p>
        <div className="activity7">
          <div className="head">
            <h3>７ ACTIVITIES AREA</h3>
            <p className="subLead1">本当に役立つオフィスをつくるヒント。<br />「７アクティビティ」で構成されたエリアをご用意。</p>
            <p className="subLead2">
              時代とともに働き方にも大きな変化がみられるいま、ワークプレイスに必要なものはなにか。<br className="hideSp" />
              東京ショールームでは、働くという行為のなかの行動要素（アクティビティ）のうち、<br className="hideSp" />
              いま、そして今後も重要になると考えられる７つのカテゴリーで構成されたエリアをご用意しました。<br />
              それぞれのオフィスにおいて注力すべきアクティビティを知ることで、<br className="hideSp" />
              本当に役立つ空間づくりとそれをカタチにするオフィス家具が明確になる。<br />
              ７つのアクティビティをオフィスづくりのヒントにしてください。
            </p>
          </div>
          <div className="body">
            <ul>
              <li>オペレーションワーク</li>
              <li>チームビルディング</li>
              <li>チームシンキング</li>
              <li>高集中ワーク</li>
              <li>特殊・専門ワーク</li>
              <li>社外関係構築</li>
              <li>高機密性ワーク</li>
              <li></li>
            </ul>
          </div>
        </div>
        <div className="btnArea">
          <Link to="/digital/fair2021/showroom/activity.html">7 ACTIVITIESエリアを見る</Link>
        </div>
      </section>

      <section id="floor">
        <h2 className="c-h2">FLOOR MAP</h2>
        <div className="lead">業務内容をはじめ各種ブランドやワークスタイルで構成されているショールームフロア。<br />
          気になるエリアが見つかったらすぐにチェック。
        </div>
        <h3>4F</h3>
        <FloorMap4 active={-1} />
        <h3>3F</h3>
        <FloorMap3 active={-1} />
      </section>

      {/* <section id="news">
        <h2 className="c-h2">NEWS</h2>
        <div className="list">
          <dl>
            <dt>2020.11.20</dt><dd>ライブオフィス「Shinagawa NX」がフルリニューアルオープンいたしました。</dd>
          </dl>
          <dl>
            <dt>2020.11.20</dt><dd>ライブオフィス「Shinagawa NX」がフルリニューアルオープンいたしました。</dd>
          </dl>
          <dl>
            <dt>2020.11.20</dt><dd>ライブオフィス「Shinagawa NX」がフルリニューアルオープンいたしました。</dd>
          </dl>
        </div>
      </section> */}

      <section id="vr">
        <h2 className="c-h2">VR CONTENTS</h2>
        <div className="list">
          <ul>
            <li><a href="https://yulio.com/rItVbjCPjR" rel="noreferrer" target="_blank"><img src="/digital/fair2021/showroom/asset/index/vr03.png" alt="" /><span className="caption">inframe</span></a></li>
            <li><a href="https://yulio.com/bAjBsPoWTQ" rel="noreferrer" target="_blank"><img src="/digital/fair2021/showroom/asset/index/vr01.png" alt="" /><span className="caption">Collesso+Region</span></a></li>
            <li><a href="https://yulio.com/w4g7OxHvxz" rel="noreferrer" target="_blank"><img src="/digital/fair2021/showroom/asset/index/vr02.png" alt="" /><span className="caption">Franka+Patio</span></a></li>
            <li><a href="https://yulio.com/neRAUOkJGg" rel="noreferrer" target="_blank"><img src="/digital/fair2021/showroom/asset/index/vr04.png" alt="" /><span className="caption">Solana</span></a></li>
          </ul>
        </div>
      </section>

      {/* <section id="links">
        <h2 className="c-h2">LINKS</h2>
        <div className="list">
          <ul>
            <li><a href="https://fair2021.kokuyo-furniture.co.jp/"><img src={`${props.testPath}/asset/index/links01.png`} alt="" /></a></li>
            <li><a href="https://fair2021.kokuyo-furniture.co.jp/lprl/wx/index.html"><img src={`${props.testPath}/asset/index/links02.png`} alt="" /></a></li>
            <li><a href="https://fair2021.kokuyo-furniture.co.jp/lprl/liveoffice/index.html"><img src={`${props.testPath}/asset/index/links03.png`} alt="" /></a></li>
          </ul>
        </div>
      </section> */}

      <section id="information">
        <h2 className="c-h2">INFORMATION</h2>
        <div className="list">
          <ul>
            <li><a href="https://www.kokuyo-furniture.co.jp/showroom/tokyo-sr/"><img src="/digital/fair2021/showroom/asset/index/info01.png" alt="" /></a></li>
            <li><Link to="/digital/fair2021/showroom/access.html"><img src="/digital/fair2021/showroom/asset/index/info02.png" alt="" /></Link></li>
          </ul>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PageIndex;
